import { Box, Typography } from '@mui/material';

import apple2 from './apple2.png';
import google2 from './google2.png';
import screenshots from './screenshots.png';
import './App.css';

function App() {
  return (
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', bgcolor:'#a974f7', minHeight:'100vh'}}>
        
        {/* <Box sx={{position:'absolute', top:'1%', right:'1%'}}><img src={circlelogo} /></Box> */}
        <Box sx={{display:'flex', flexDirection:'row', width:'80%'}}>
          
          
          <Box sx={{flex:1.5, bgcolor:'#a974f7', justifyContent:'center', display:'flex'}}><img src={screenshots} height={685} width={365} alt="logo" /></Box>
          <Box sx={{flex:2.5, bgcolor:'#a974f7', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
            <Typography fontSize={24} fontWeight={'bold'} color={'#e6ccfc'}>Alani Baby Tracker is a simple yet powerful app for parents.</Typography>
            <Typography color={'whitesmoke'} sx={{marginBottom:7}}>We value your family's privacy so we don't require any personal information from you.</Typography>
            <Box sx={{mb:5}}>        
              <Typography color={'#a974f7'} fontWeight={'bold'}>Features</Typography>
              <Typography color={'whitesmoke'}>- multiple baby support</Typography>
              <Typography color={'whitesmoke'}>- track baby's milestones</Typography>
              <Typography color={'whitesmoke'}>- get pump notifications</Typography>
              <Typography color={'whitesmoke'}>- track your pump stash</Typography>
              <Typography color={'whitesmoke'}>- calendar for daily and historical data</Typography>
              <Typography color={'whitesmoke'}>- sync multiple accounts to the same milk id</Typography>
              <Typography color={'whitesmoke'}>- track feedings, diaper changes and pump sessions</Typography>
            </Box>
            <Box sx={{display:'flex', flexDirection:'row'}}>
              <Box sx={{mr:1}}><img src={apple2} /></Box>
              <Box sx={{ml:1}}><img src={google2} /></Box>
            </Box>
          </Box>
        </Box>
        
        <Typography color={'whitesmoke'} fontSize={10}>© ALL RIGHTS RESERVED, Grace Solutions</Typography>
        <Typography sx={{mb:5}} color={'whitesmoke'} fontSize={10}>contact us: support@alanibabytracker.com</Typography>

    </Box> 
  );
}

export default App;
